import { Operateur } from '../../intervenant/models/operateur.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class OperateurExport extends Operateur {
    static jsonMap = {
        ...Operateur.jsonMap,
        cvi: { key: 'cvi', optional: true, default: '' }
    };

    public cvi: string;
}
